import type { Row } from 'react-table';

import type { DuplicateLineItem } from '../../../../../DuplicateAdsStepperProvider/types';

export type GetUpdatedInitialLineItemsProps = {
  lineItemsWithInitiallyDeselected: DuplicateLineItem[];
  selectedRowIds: Record<string, boolean>;
  rows: Row<DuplicateLineItem>[];
  adId: string;
};

export const getUpdatedInitialLineItems = ({
  lineItemsWithInitiallyDeselected,
  selectedRowIds,
  rows,
  adId,
}: GetUpdatedInitialLineItemsProps): DuplicateLineItem[] => {
  return lineItemsWithInitiallyDeselected.reduce((acc, lineItem) => {
    const isSelectedInTheTable = selectedRowIds[lineItem.id];
    const isInitiallyDeselected = lineItem.initiallyDeselectedForAdIds.includes(adId);
    const isInTheSearchTable = !!rows.find(({ id }) => id === lineItem.id);

    const newLineItem = { ...lineItem };

    if (isSelectedInTheTable) {
      newLineItem.selected = true;

      if (!lineItem.selected && isInitiallyDeselected) {
        newLineItem.initiallyDeselectedForAdIds = [];
      }

      acc.push(newLineItem);
    } else {
      // if line item is deselected initially for specific ad,
      // line item should be selected for other ads
      if (!lineItem.selected && isInitiallyDeselected) {
        newLineItem.selected = true;
      }

      // if line items is saved and has not been searched or were not changed,
      // then it should stay in array
      if (!isInTheSearchTable || !lineItem.selected) {
        acc.push(newLineItem);
      }
    }

    return acc;
  }, new Array<DuplicateLineItem>());
};

export const isDifferentSelectionFromSaved = (selectedRowIds: string[], selectedSavedRowIds: string[]): boolean => {
  if (selectedRowIds.length !== selectedSavedRowIds.length) return true;

  const anyNewSelected = selectedRowIds?.some((selectedRowId) => !selectedSavedRowIds?.includes(selectedRowId));
  const anyNewDeSelected = selectedSavedRowIds?.some((selectedRowId) => !selectedRowIds?.includes(selectedRowId));

  return anyNewSelected || anyNewDeSelected;
};
